import { AlertStatus } from '@models/alert';
import { InternalQuoteStatus, QuoteStatusId } from '@models/quotes';

export interface RelatedContinuedQuoteSummary {
  quoteId: string;
  quoteNumber?: string | null;
  statusId?: string | null;
}

export interface RelatedContinuedQuotesBanner {
  type: AlertStatus.Warning;
  quotes: Array<
    RelatedContinuedQuoteSummary & {
      displayQuoteNumber: string;
      statusLabel: string;
    }
  >;
}

const ACTIVE_CONTINUED_QUOTE_STATUSES = new Set<string>([
  QuoteStatusId.Submission,
  QuoteStatusId.ReadyForRating,
  QuoteStatusId.Rated,
  QuoteStatusId.Referred,
  QuoteStatusId.Underwritten,
  QuoteStatusId.ReadyToBind,
]);

const getContinuedQuoteStatusLabel = (statusId?: string | null) => {
  if (!statusId) {
    return 'Unknown';
  }

  return InternalQuoteStatus[statusId] ?? statusId;
};

export const getRelatedContinuedQuotesBanner = ({
  isInternalUser,
  relatedContinuedQuotes,
}: {
  isInternalUser: boolean;
  relatedContinuedQuotes?: RelatedContinuedQuoteSummary[] | null;
}): RelatedContinuedQuotesBanner | undefined => {
  if (!isInternalUser) {
    return undefined;
  }

  const unboundContinuedQuotes = (relatedContinuedQuotes ?? [])
    .filter((quote) => Boolean(quote.quoteId))
    .filter((quote) => quote.statusId && ACTIVE_CONTINUED_QUOTE_STATUSES.has(quote.statusId))
    .map((quote) => ({
      ...quote,
      displayQuoteNumber: quote.quoteNumber || quote.quoteId,
      statusLabel: getContinuedQuoteStatusLabel(quote.statusId),
    }));

  if (unboundContinuedQuotes.length === 0) {
    return undefined;
  }

  return {
    type: AlertStatus.Warning,
    quotes: unboundContinuedQuotes,
  };
};
